import React from 'react';

const Mission = () => {
  return (
    <section className="py-24 bg-accent-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8 text-white">
            Our Mission
          </h2>
          <p className="text-lg sm:text-xl text-white max-w-4xl mx-auto leading-relaxed">
            Our mission is to empower organizations with the insights and strategies needed to achieve their business goals, shape policies, implement programs, and improve healthcare access and outcomes for those they serve. We are committed to driving health policies and practices, ensuring that all populations receive the care and support they deserve.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Mission;
